module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [(_vm.$vars.loading) ? _c('v-progress-linear', {
    staticClass: "primary--text loader",
    attrs: {
      "indeterminate": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              (_vm.showNewEintrag = true) && (_vm.neuerEintrag = {}) && (_vm.istNeu = true)
            }
          }
        }, on), [_c('v-icon', [_vm._v("add")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('span', [_vm._v("Neuer Eintrag")])]), _vm._v("\n    Wirtschaftsplan\n    "), _c('v-spacer')], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.wirtschaftsplane,
      "fixed-header": "",
      "hide-default-footer": "",
      "items-per-page": -1,
      "height": _vm.sideHeight
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('tr', {
          on: {
            "dblclick": function($event) {
              (_vm.neuerEintrag = item) && (_vm.showNewEintrag = true) && (_vm.istNeu = false)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(item.titel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.date(item.datum, "DD.MM.YYYY")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.erstelltVon, _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$filters.user(item.zuletztBearbeitet, _vm.bbrbbr)))]), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.print(item)
            }
          }
        }, [_c('v-icon', [_vm._v("print")])], 1)], 1)])]
      }
    }])
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showNewEintrag),
      callback: function($$v) {
        _vm.showNewEintrag = $$v
      },
      expression: "showNewEintrag"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "Titel",
      "hide-details": "",
      "outlined": "",
      "placeholder": "Wirtschaftsplan erstellen"
    },
    model: {
      value: (_vm.neuerEintrag.titel),
      callback: function($$v) {
        _vm.$set(_vm.neuerEintrag, "titel", $$v)
      },
      expression: "neuerEintrag.titel"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.print(_vm.neuerEintrag)
      }
    }
  }, [_c('v-icon', [_vm._v("print")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewEintrag = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-row', {
    staticClass: "ma-0 pa-0"
  }, [_vm._l((_vm.neuerEintrag.wirtschaftsplan), function(position, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      attrs: {
        "outlined": ""
      }
    }, [_c('v-card-title', [_c('v-edit-dialog', {
      attrs: {
        "persistent": "",
        "return-value": position.titel
      },
      on: {
        "update:returnValue": function($event) {
          return _vm.$set(position, "titel", $event)
        },
        "update:return-value": function($event) {
          return _vm.$set(position, "titel", $event)
        }
      },
      scopedSlots: _vm._u([{
        key: "input",
        fn: function() {
          return [_c('v-text-field', {
            attrs: {
              "label": "Bezeichnung eintragen",
              "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
              "single-line": ""
            },
            model: {
              value: (position.titel),
              callback: function($$v) {
                _vm.$set(position, "titel", $$v)
              },
              expression: "position.titel"
            }
          })]
        },
        proxy: true
      }], null, true)
    }, [_vm._v("\n                  " + _vm._s(index + 1) + ". " + _vm._s(position.titel) + "\n                  ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": "",
        "disabled": position.positionen.length !== 0
      },
      on: {
        "click": function($event) {
          return _vm.deleteBlock(position)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1), _vm._v(" "), _c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.addRow(index)
        }
      }
    }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
      attrs: {
        "headers": _vm.headersTabelle,
        "items": position.positionen,
        "fixed-header": "",
        "dense": "",
        "item.key": "position.id",
        "hide-default-header": "",
        "hide-default-footer": "",
        "items-per-page": -1,
        "no-data-text": "Keine Einträge"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function(ref) {
          return [_c('tr', [_c('th', {
            attrs: {
              "colspan": "4"
            }
          }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
            attrs: {
              "width": "2px"
            }
          }, [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Soll-Einnahmen")]), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Soll-Ausgaben")]), _vm._v(" "), _c('th', {
            attrs: {
              "width": "2px"
            }
          }, [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Ist-Einnahmen")]), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Ist-Ausgaben")]), _vm._v(" "), _c('th', {
            attrs: {
              "width": "2px"
            }
          }, [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "140px"
            }
          }, [_vm._v("Differenz")]), _vm._v(" "), _c('th', {
            staticClass: "text-right",
            attrs: {
              "width": "120px"
            }
          }), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), _c('tr', [_c('th', {
            attrs: {
              "colspan": "14"
            }
          }, [_c('v-divider')], 1)])]
        }
      }, {
        key: "item",
        fn: function(props) {
          return [(props.item.positionen.length > 0) ? _c('tr', {
            staticClass: "grey lighten-2"
          }, [_c('td', {
            staticClass: "text-left",
            attrs: {
              "colspan": "4"
            }
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.bezeichnung
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "bezeichnung", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "bezeichnung", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Bezeichnung eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.bezeichnung),
                    callback: function($$v) {
                      _vm.$set(props.item, "bezeichnung", $$v)
                    },
                    expression: "props.item.bezeichnung"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(props.item.bezeichnung) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")(_vm.getSum(props.item, "einnahmen"))) + "\n                    ")]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")(_vm.getSum(props.item, "ausgaben"))) + "\n                    ")]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")(_vm.getSum(props.item, "istEinnahmen"))) + "\n                    ")]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")(_vm.getSum(props.item, "istAusgaben"))) + "\n                    ")]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(props.item.istEinnahmen || props.item.istAusgaben) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("money")((props.item.istEinnahmen -
            props.item.einnahmen -
            props.item.istAusgaben +
            props.item.ausgaben))) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.addGroupRow(props.item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), (props.item.positionen.length === 0) ? _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteRow(props.item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("delete")])], 1) : _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                $event.stopPropagation();
                props.item.show = !props.item.show
              }
            }
          }, [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1)], 1)]) : _c('tr', {
            staticClass: "grey lighten-2"
          }, [_c('td', {
            staticClass: "text-left",
            attrs: {
              "colspan": "4"
            }
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.bezeichnung
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "bezeichnung", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "bezeichnung", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Bezeichnung eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.bezeichnung),
                    callback: function($$v) {
                      _vm.$set(props.item, "bezeichnung", $$v)
                    },
                    expression: "props.item.bezeichnung"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(props.item.bezeichnung) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.einnahmen
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "einnahmen", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "einnahmen", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Einnahmen eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.einnahmen),
                    callback: function($$v) {
                      _vm.$set(props.item, "einnahmen", $$v)
                    },
                    expression: "props.item.einnahmen"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(_vm._f("money")(props.item.einnahmen)) + "\n                        ")])], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.ausgaben
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "ausgaben", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "ausgaben", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Ausgaben eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.ausgaben),
                    callback: function($$v) {
                      _vm.$set(props.item, "ausgaben", $$v)
                    },
                    expression: "props.item.ausgaben"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(_vm._f("money")(props.item.ausgaben)) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.istEinnahmen
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "istEinnahmen", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "istEinnahmen", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Ist Einnahmen eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.istEinnahmen),
                    callback: function($$v) {
                      _vm.$set(props.item, "istEinnahmen", $$v)
                    },
                    expression: "props.item.istEinnahmen"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(_vm._f("money")(props.item.istEinnahmen)) + "\n                        ")])], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-edit-dialog', {
            attrs: {
              "persistent": "",
              "return-value": props.item.istAusgaben
            },
            on: {
              "update:returnValue": function($event) {
                return _vm.$set(props.item, "istAusgaben", $event)
              },
              "update:return-value": function($event) {
                return _vm.$set(props.item, "istAusgaben", $event)
              },
              "save": function($event) {
                return _vm.onChange()
              }
            },
            scopedSlots: _vm._u([{
              key: "input",
              fn: function() {
                return [_c('v-text-field', {
                  attrs: {
                    "label": "Ist Ausgaben eintragen",
                    "hint": "Zum Bestätigen Enter drücken, mit ESC abbrechen.",
                    "single-line": ""
                  },
                  model: {
                    value: (props.item.istAusgaben),
                    callback: function($$v) {
                      _vm.$set(props.item, "istAusgaben", $$v)
                    },
                    expression: "props.item.istAusgaben"
                  }
                })]
              },
              proxy: true
            }], null, true)
          }, [_vm._v("\n                        " + _vm._s(_vm._f("money")(props.item.istAusgaben)) + "\n                        ")])], 1), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [(props.item.istAusgaben || props.item.istEinnahmen) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("money")(_vm.getDiff(props.item))) + "\n                      ")]) : _vm._e()]), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.addGroupRow(props.item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("playlist_add")])], 1), _vm._v(" "), _c('v-btn', {
            attrs: {
              "icon": ""
            },
            on: {
              "click": function($event) {
                return _vm.deleteRow(props.item, index)
              }
            }
          }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)]), _vm._v(" "), _vm._l((props.item.positionen), function(pos, index) {
            return (props.item.show && props.item.positionen) ? _c('rowWirtschaftsplan', {
              key: index,
              attrs: {
                "parent": props.item,
                "ebene": 1,
                "item": pos
              }
            }) : _vm._e()
          })]
        }
      }, {
        key: "body.append",
        fn: function(props) {
          return [_c('tr', {
            staticClass: "grey lighten-2"
          }, [_c('td', {
            attrs: {
              "width": "20px"
            }
          }), _vm._v(" "), _c('td', {
            attrs: {
              "width": "20px"
            }
          }), _vm._v(" "), _c('td', {
            attrs: {
              "width": "20px"
            }
          }), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v("Summe:")]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "einnahmen"))))]), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "ausgaben"))))]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "istEinnahmen"))))]), _vm._v(" "), _c('td', {
            staticClass: "text-right font-weight-bold"
          }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "istAusgaben"))))]), _vm._v(" "), _c('td', [_c('v-divider', {
            attrs: {
              "vertical": ""
            }
          })], 1), _vm._v(" "), _c('td', {
            staticClass: "text-right"
          }, [_vm._v("\n                      " + _vm._s(_vm._f("money")((parseFloat(_vm.getSum(position, "istEinnahmen")) -
            parseFloat(_vm.getSum(position, "einnahmen")) -
            parseFloat(_vm.getSum(position, "istAusgaben")) +
            parseFloat(_vm.getSum(position, "ausgaben"))))) + "\n                    ")]), _vm._v(" "), _c('td')])]
        }
      }], null, true)
    })], 1)], 1)
  }), _vm._v(" "), _c('v-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": ""
    },
    on: {
      "click": function($event) {
        return _vm.addBlock()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "outlined": ""
    }
  }, [_c('v-card-title', [_vm._v(" Summe ")]), _vm._v(" "), _c('v-simple-table', {
    attrs: {
      "fixed-header": "",
      "dense": ""
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-left",
    attrs: {
      "width": "80px"
    }
  }, [_vm._v("Position")]), _vm._v(" "), _c('th', {
    staticClass: "text-left"
  }, [_vm._v("Bezeichnung")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Soll-Einnahmen")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Soll-Ausgaben")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Ist-Einnahmen")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Ist-Ausgaben")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "2px"
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "width": "140px"
    }
  }, [_vm._v("Differenz")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "120px"
    }
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.neuerEintrag.wirtschaftsplan), function(position, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(position.titel))]), _vm._v(" "), _c('td', [_c('v-divider', {
      attrs: {
        "vertical": ""
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "einnahmen"))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "ausgaben"))))]), _vm._v(" "), _c('td', [_c('v-divider', {
      attrs: {
        "vertical": ""
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "istEinnahmen"))))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getSum(position, "istAusgaben"))))]), _vm._v(" "), _c('td', [_c('v-divider', {
      attrs: {
        "vertical": ""
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm._f("money")(_vm.getDiff(position))))]), _vm._v(" "), _c('td')])
  }), _vm._v(" "), _c('tr', {
    staticClass: "grey lighten-2"
  }, [_c('td'), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v("Endstand:")]), _vm._v(" "), _c('td', [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summen[0])))]), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summen[1])))]), _vm._v(" "), _c('td', [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summen[2])))]), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v(_vm._s(_vm._f("money")(_vm.summen[3])))]), _vm._v(" "), _c('td', [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "text-right font-weight-bold"
  }, [_vm._v("\n                      " + _vm._s(_vm._f("money")((_vm.summen[2] - _vm.summen[0] - _vm.summen[3] + _vm.summen[1]))) + "\n                    ")]), _vm._v(" "), _c('td')])], 2)])], 1)], 1)], 2)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.showNewEintrag = false
      }
    }
  }, [_vm._v("Abbrechen")]), _vm._v(" "), (_vm.istNeu) ? _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveNeuEintrag()
      }
    }
  }, [_vm._v("Erstellen")]) : _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "dark": "",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveEintrag()
      }
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d960487"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/wirtschaftsplan.vue
// module id = 794
// module chunks = 15